import React, { FC, ImgHTMLAttributes } from "react";

import defaultLogoSrc from "@/images/default-logo.svg";

export type LogoImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src?: string | null;
};

export const LogoImage: FC<LogoImageProps> = ({ src, alt = "", ...rest }) => (
  <img src={src || defaultLogoSrc} alt={alt} {...rest} />
);

export default LogoImage;
